module.exports = __webpack_public_path__ + "img/569422.62727a3b.svg";